module.exports = __webpack_public_path__ + "img/dark.d4711137.svg";